export default {
  form: {
    country: {
      label: 'Țară',
      placeholder: 'Selectați țara',
    },
  },
};
